import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCap16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCap16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m8 2.92 5.893 3.178L8 9.278l-5.894-3.18zm-.475-.88a1 1 0 0 1 .95 0l5.893 3.178a1 1 0 0 1 0 1.76L13 7.717v2.9l-.052.105-.448-.222c.448.222.448.223.447.223v.002l-.002.004-.005.01-.015.026q-.018.033-.05.085-.064.107-.192.272a4.2 4.2 0 0 1-.824.782C11.084 12.47 9.855 13 8 13c-1.279 0-2.26-.252-3-.594v1.576L3.5 14 2 13.982v-2.489c0-.65.417-1.203 1-1.408V7.717l-1.368-.739a1 1 0 0 1 0-1.76zM5 11.47v-.195c.62.376 1.575.725 3 .725 1.651 0 2.672-.469 3.27-.904a3.2 3.2 0 0 0 .628-.593q.064-.085.102-.141V8.256l-3.525 1.902a1 1 0 0 1-.95 0L4 8.256v1.829c.576.203.99.745 1 1.386m-1 .028v-.005A.497.497 0 0 0 3.5 11c-.28 0-.5.225-.5.493v1.501l.5.006.5-.006v-1.496"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCap16);
